/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorQuotebox from 'base/components/labrador/Quotebox';

export const DynamicLabradorQuotebox: typeof LabradorQuotebox = (props) => {
    return <ErrorBoundary><LabradorQuotebox {...props} /></ErrorBoundary>;
}
export type DynamicLabradorQuoteboxProps = PropsFromComponent<typeof LabradorQuotebox>;
